import * as React from "react"
import Select, { StylesConfig } from "react-select";

const customDropdownStyles: StylesConfig = {
    control: styles => ({
        ...styles,
        borderRadius: 0,
        border: 0,
        borderBottom: "solid 1px #b6c6d7",
        width: "100px",
        boxShadow: "none",
        "&:hover": {
            boxShadow: 0,
            borderBottom: "solid 1px #e4306e"
        }
    }),
    indicatorSeparator: styles => ({
        ...styles,
        display: "none"
    }),
    singleValue: styles => ({
        ...styles,
        fontFamily: "BrandonTextWeb-Regular",
        fontSize: 14,
        color: "rgb(0, 0, 0)"
    }),
    indicatorsContainer: styles => ({
        ...styles,
        padding: 0
    }),
    menu: styles => ({
        ...styles,
        width: "100px"
    }),
    valueContainer: styles => ({
        ...styles,
        padding: 0
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: 0
    }),
    menuPortal: styles => ({
        ...styles,
        zIndex: 9999
    })
};

const NewTimeSlotPicker = (props: any) => {
    return <Select styles={customDropdownStyles} {...props} onBlur={event => event.preventDefault()} />
}

export default NewTimeSlotPicker